/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CoachTaskAction interface.
 */
export function instanceOfCoachTaskAction(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "canCompleteDirectly" in value;
    return isInstance;
}
export function CoachTaskActionFromJSON(json) {
    return CoachTaskActionFromJSONTyped(json, false);
}
export function CoachTaskActionFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json.id,
        title: json.title,
        canCompleteDirectly: json.canCompleteDirectly,
    };
}
export function CoachTaskActionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        title: value.title,
        canCompleteDirectly: value.canCompleteDirectly,
    };
}
